let _navigator;

function setTopLevelNavigator(navigatorRef) {
  _navigator = navigatorRef;
}

function navigate() {}

function drawer() {}

// add other navigation functions that you need and export them

export default {
  navigate,
  setTopLevelNavigator,
  drawer
};
